
export const towing_elec_per_ton = 5;
export const mining_laser_elec_per_sec = 6000;
export const collector_elec_per_sec = 6000;
